// extracted by mini-css-extract-plugin
module.exports = {"root":"_2gZg-","button":"_3Cx3v","icon":"_22MNd","text":"_4YBTR","large":"_1C2v3"};